"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheSwitch = void 0;

var _react = _interopRequireDefault(require("react"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _core = require("../core");

var _utils = require("../utils");

var _switch = require("./switch.style");

var _excluded = ["classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Switches toggle the state of a single setting on or off. They are the preferred way to adjust settings on
 * mobile.
 * The option that the switch controls, as well as the state it’s in, should be made clear from the corresponding
 * inline label.
 */
var RocheSwitch = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classes = props.classes,
      rest = _objectWithoutProperties(props, _excluded);

  var innerClasses = (0, _utils.mergeClasses)((0, _switch.useStyles)(), classes);
  return /*#__PURE__*/_react["default"].createElement(_Switch["default"], _extends({}, rest, {
    ref: ref,
    classes: innerClasses
  }));
});

exports.RocheSwitch = RocheSwitch;
RocheSwitch.displayName = (0, _core.rochePrefix)('Switch');
RocheSwitch.defaultProps = {
  color: 'primary'
};
var _default = RocheSwitch;
exports["default"] = _default;